<div *ngIf="!multiLine">
  <label *ngIf="showLabel" id="lbl{{ name }}" for="{{ name }}" class="form__label Body-Small-Book">{{ label }}</label>
  <div class="input-group" [ngClass]="{ input__addon_error: isError }">
    <span *ngIf="iconStyle && iconColor" class="icon">
      <i (click)="onIconClick($event)" ngClass="{{ iconStyle }}" [style.color]="iconColor"></i>
    </span>
    <span *ngIf="prefix" class="input-group-addon prefix Body-Book">{{ prefix }}</span>
    <input
      [class.raw]="!prefix && !suffix && !iconStyle"
      [class.suffix-only]="suffix && !prefix"
      class="Body-Book"
      [disabled]="disabled"
      attr.aria-label="lbl{{name}}"
      [maxLength]="maxLength"
      name="{{ name }}"
      id="{{ name }}"
      type="{{ type }}"
      [attr.inputmode]="inputMode"
      placeholder="{{ placeholder }}"
      [(ngModel)]="value"
      [ngModelOptions]="updateOptionObject"
      [ngClass]="{ error: isError, input_padding: prefix || iconStyle }"
      [autocomplete]="autocomplete"
      (blur)="onBlur(value)"
    />
    <span *ngIf="suffix" class="input-group-addon suffix Body-Book">{{ suffix }}</span>
    <span *ngIf="passwordShowOption" class="icon">
      <i
        (click)="togglePasswordVisibility()"
        [ngClass]="{
          'far eye-style': passwordShowOption,
          'fa-eye eye-style-dark': isPasswordVisible(),
          'fa-eye-slash': !isPasswordVisible()
        }"
      ></i>
    </span>
  </div>
</div>
<div *ngIf="multiLine">
  <label for="{{ idMultiline }}" class="form__label Body-Small-Book">{{ label }}</label>
  <textarea
    name="{{ idMultiline }}"
    id="{{ idMultiline }}"
    [attr.aria-label]="label"
    [(ngModel)]="value"
    [maxLength]="maxLength"
    [disabled]="disabled"
    class="form__multiline--input Body-Book"
    [ngClass]="{ error: isError, text_area: isError }"
    placeholder="{{ placeholder }}"
  ></textarea>
  <div *ngIf="showCharacterCount && maxLength" class="charcount">
    {{ value.toString().length + ' / ' + (maxLength | number) }}
  </div>
</div>
<div *ngIf="errorMessage && isError">
  <label class="form__error Body-Small error_container">
    <div>
      <span class="error__icon"><i class="far fa-fw fa-times"></i></span>
    </div>
    <div>
      <span class="Body-Small-Book">{{ errorMessage }}</span>
    </div>
  </label>
</div>
